import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Busy from '../../components/busy/Busy';
import {Outlet} from "react-router-dom"
const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  console.log('ProtectedRoute user:', user);

  // Wait for auth state to be resolved
  if (loading) {
    return <Busy />; // You can customize this spinner or loader
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet/>;
};

export default ProtectedRoute;
